// extracted by mini-css-extract-plugin
export var brand = "_am-9";
export var compact = "_am-6";
export var extraSmall = "_am-7";
export var icon = "_am-0";
export var large = "_am-4";
export var light = "_am-1";
export var medium = "_am-5";
export var outline = "_am-b";
export var primaryDark = "_am-a";
export var primaryLight = "_am-8";
export var primaryModern = "_am-c";
export var success = "_am-2";
export var successSolid = "_am-3";